import getConfig from 'next/config';
import { generateLogger } from './logger';
var publicRuntimeConfig = getConfig().publicRuntimeConfig;
var _a = publicRuntimeConfig.app, appVersion = _a.version, level = _a.logger.level, datadog = publicRuntimeConfig.datadog;
var datadogConfig = (datadog === null || datadog === void 0 ? void 0 : datadog.logs) && (datadog === null || datadog === void 0 ? void 0 : datadog.clientToken) ? datadog : undefined;
/**
 * Creates an instance of the logger for NextJS app contexts
 *
 * Note that this logger is not intended for logging from NextJS
 * middlewares.
 *
 * @param  {...any} args
 * @returns
 */
var logger = generateLogger('app_logger', {
    appVersion: appVersion,
    level: level,
    datadog: datadogConfig,
});
export default logger;
